import { Button } from '@change/ds-core-ui';

import type { TranslationKey } from '@change-corgi/core/i18n';
import { Translate } from '@change-corgi/core/react/i18n';
import { Box } from '@change-corgi/design-system-legacy/layout';
import type { ExportPetitionContentType } from '@change-corgi/middle-end-gql-schema';

type ExportContentType = 'SIGNATURES' | 'COMMENTS';

type Props = Readonly<{
	exportType: ExportContentType;
	data: {
		shouldHideExport: boolean;
		loading: boolean;
		errorMessage: TranslationKey | null;
		successMessage: TranslationKey | null;
	};
	actions: {
		handleExport: (type: ExportPetitionContentType) => Promise<void>;
	};
}>;

export const ExportButton: React.FC<Props> = ({ exportType, data, actions }) => {
	if (data.shouldHideExport) return null;

	return (
		<Box>
			<Box aria-atomic="true" aria-live="polite">
				{!data.loading && !data.errorMessage && (
					<Box data-qa="export-petition-box">
						<Button
							data-testid="starter-dashboard-export-button"
							data-qa="starter-dashboard-export-button"
							type="button"
							aria-label="starter-dashboard-export-button"
							variant="secondary"
							size="x-small"
							disabled={data.loading}
							onClick={async () => {
								await actions.handleExport(exportType);
							}}
						>
							<Translate value="corgi.petition.starter_dashboard.shared.export_button.btn_text" />
						</Button>
					</Box>
				)}
			</Box>
		</Box>
	);
};
